// app/javascript/controllers/dae20/preview_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["count"]
  static values = {
    templateId: String,
    url: String
  }

  connect() {
    console.log("[dae20] Preview controller connected")
    this.loadRecordCount()
  }

  async loadRecordCount() {
    try {
      const filters = this.collectFilters()
      // Fallback URL: dae20 namespace
      let url = this.urlValue || `/dae20/item_templates/${this.templateIdValue}/record_count`

      if (filters) {
        const filterParams = new URLSearchParams()
        Object.keys(filters).forEach(key => {
          const value = filters[key];
          if (typeof value === 'object' && value !== null) {
            Object.keys(value).forEach(op => {
              filterParams.append(`filters[${key}][${op}]`, value[op])
            })
          } else {
            filterParams.append(`filters[${key}]`, value)
          }
        })
        url += `?${filterParams.toString()}`
      }

      const response = await fetch(url)
      if (response.ok) {
        const data = await response.json()
        if (this.hasCountTarget) {
          this.countTarget.textContent = data.count
        }
      }
    } catch (error) {
      console.error("[dae20] Error loading record count:", error)
    }
  }

  collectFilters() {
    const filterRows = document.querySelectorAll('.source-filter-row')
    const filters = {}

    filterRows.forEach(row => {
      // Первый select — поле, второй (если есть) — value_type
      const fieldSelect = row.querySelector('select[name*="field_name"]')
      const conditionInput = row.querySelector('input[type="text"]')

      if (fieldSelect && conditionInput) {
        const fieldName = fieldSelect.value
        const condition = conditionInput.value

        if (fieldName && condition) {
          const match = condition.match(/^([<>=]=?|!=|<>|like|ilike|between|in)\s+(.+)$/i)
          if (match) {
            const operator = match[1]
            const value = match[2]
            const opMap = {
              '=': 'eq',
              '==': 'eq',
              '!=': 'ne',
              '<>': 'ne',
              '>': 'gt',
              '>=': 'gte',
              '<': 'lt',
              '<=': 'lte',
              'like': 'like',
              'ilike': 'ilike'
            }
            const normalizedOp = opMap[operator.toLowerCase()] || 'eq'
            filters[fieldName] = { [normalizedOp]: value }
          } else {
            filters[fieldName] = { 'eq': condition }
          }
        }
      }
    })

    return Object.keys(filters).length > 0 ? filters : null
  }
}
